import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {IndustryService} from '@app/services/industry.service';
import {DcpIndustryModel} from './dcp-industry.model';
import {CmsComponentData} from '@spartacus/storefront';
import {
  CmsFlexComponentData
} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {ComponentService} from '@app/services/component.service';
import {FetchTextsComponent} from '@app/shared/fetch-texts/fetch-texts.component';

@Component({
  selector: 'dcp-browse-industry',
  templateUrl: './browse-industry.component.html',
  styleUrls: ['./browse-industry.component.scss']
})
export class BrowseIndustryComponent extends FetchTextsComponent implements OnInit {
  industries: Array<DcpIndustryModel>;
  componentTexts: { headline: string };

  constructor(public industryService: IndustryService,
              protected cmsData: CmsComponentData<CmsFlexComponentData>,
              protected componentService: ComponentService,
              protected cdr: ChangeDetectorRef) {
    super(cmsData, componentService, cdr);
  }

  ngOnInit() {
    this.industries = this.industryService.getIndustries();
    this.fetchComponentData();
  }

  /**
   * Show Product for Industry
   *
   * @param industry selected industry
   */
  openSearchResult(industry: DcpIndustryModel): void {
    this.industryService.displayProductsOfIndustry(industry);
  }
}
